import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ImportReportDialogData } from '../project-imports.interface';
import { XferReportFormat } from '../../shared/models/xfer.model';

@Component({
  host: { 'test-id': 'import-report-dialog' },
  selector: 'import-report-dialog',
  styleUrls: ['./import-report-dialog.component.scss'],
  templateUrl: './import-report-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportReportDialog implements OnDestroy {
  @Input() importId = this.data.importId;

  loading = false
  formatOptions = [
    { title: 'CSV', value: XferReportFormat.CSV },
    { title: 'JSONL', value: XferReportFormat.JSONL },
  ]
  reportSettings: FormGroup = new FormGroup({
    format: new FormControl(XferReportFormat.CSV, [Validators.required]),
  })

  private subscriptions = {
    download: Subscription.EMPTY,
  }

  constructor(
    @Inject(DIALOG_DATA) protected data: ImportReportDialogData,
    private dialogRef: DialogRef<ImportReportDialog>,
  ) { }

  ngOnDestroy(): void {
    for (const subscription of Object.values(this.subscriptions)) {
      subscription.unsubscribe();
    }
  }

  downloadReport(): void {
    this.loading = true;
    this.reportSettings.disable();
    this.data.onSubmit(this.reportSettings.value.format);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
